import type { ReactNode } from "react";
import { usePlan } from "../plan.context";
import Button from "~/components/ui/Button";

interface PurchaseProps {
  paymentUrl: string;
  label: string;
  utm_term?: string;
  useRef?: boolean;
  queryParams?: Record<string, string | number>; 
  children: Readonly<ReactNode>;
}

export default function Purchase({
  paymentUrl,
  label,
  utm_term,
  useRef,
  queryParams,
  children,
}: PurchaseProps) {
  const { color } = usePlan();

  return (
    <div className="flex items-center gap-4">
      <Button
        link={paymentUrl}
        utm_term={utm_term}
        useRefLink={useRef}
        variant={color}
        queryParams={queryParams}
      >
        {label}
      </Button>
      <span className="text-sm text-gray-300">{children}</span>
    </div>
  );
}
